import { render, staticRenderFns } from "./EventChulsuk.vue?vue&type=template&id=0683732c&scoped=true"
import script from "./EventChulsuk.vue?vue&type=script&lang=js"
export * from "./EventChulsuk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683732c",
  null
  
)

export default component.exports